import React from "react";

export default function EmptyState({ title, description, image, action, icon: Icon, testid }) {
  return (
    <div
      data-testid={testid || "empty-state"}
      className="ds-card p-10 md:p-14 flex flex-col items-center text-center"
    >
      {image ? (
        <div className="w-40 h-40 md:w-48 md:h-48 rounded-2xl overflow-hidden mb-6 ring-1 ring-[hsl(var(--border-default))]">
          <img src={image} alt="" className="w-full h-full object-cover" />
        </div>
      ) : Icon ? (
        <div className="w-16 h-16 rounded-2xl bg-[hsl(var(--brand-light))] text-[hsl(var(--brand))] flex items-center justify-center mb-5">
          <Icon className="w-7 h-7" />
        </div>
      ) : null}
      <h3 className="text-xl font-semibold tracking-tight" style={{fontFamily:"'Outfit',sans-serif"}}>
        {title}
      </h3>
      {description && (
        <p className="text-sm text-[hsl(var(--text-secondary))] mt-2 max-w-md">{description}</p>
      )}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
